import GitGrep from "../../../../src/posts/2019-06-18-js-strict-mode/git-grep";
import * as React from 'react';
export default {
  GitGrep,
  React
};